import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "avatar-container" }
const _hoisted_2 = {
  key: 0,
  class: "thinking-orbit",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlledGif = _resolveComponent("ControlledGif")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar-panel", {
      'full-width': _ctx.fullWidth,
      'agent-speaking': _ctx.isAgentSpeaking,
      'agent-thinking': _ctx.isAgentThinking,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ControlledGif, {
        src: _ctx.avatarImage,
        playing: _ctx.isAgentSpeaking,
        alt: "Avatar",
        class: "avatar-gif"
      }, null, 8, ["src", "playing"]),
      (_ctx.isAgentThinking && !_ctx.isAgentSpeaking)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}